import { EstadoNormativo, EstadoFiltroFiltro, EstadoFitroFiltroPesquisa, IEstadoLocalStorage } from "./modulos/normativo/index";
import { InjectionKey } from "vue";
import { createStore, Store, useStore as vuexUseStore } from "vuex";
import { normativo, filtro, filtroPesquisa, localStorage } from "./modulos/normativo";

export interface Estado {
  normativo: EstadoNormativo;  
}
export interface EstadoFiltro {
  filtro: EstadoFiltroFiltro;  
}
export interface EstadoFiltroPesquisa {
  filtroPesquisa: EstadoFitroFiltroPesquisa;  
}
export interface EstadoLocalStorage {
  localStorage:IEstadoLocalStorage;
}

export const key: InjectionKey<Store<Estado>> = Symbol();
export const keyFiltro: InjectionKey<Store<EstadoFiltro>> = Symbol();
export const keyFiltroPesquisa: InjectionKey<Store<EstadoFiltroPesquisa>> = Symbol();
export const keyLocalStorage: InjectionKey<Store<EstadoLocalStorage>> = Symbol();

export const store = createStore<Estado>({
  state: {
    normativo: {
      normativos: [], 
      normativo:{codigoNorma:'', dataDocumento:'', dscSituacao:''}     
    },
  },
  modules: {
    normativo,
  },
});

export const storeFiltro = createStore<EstadoFiltro>({
  state: {
    filtro: {
      filtros: [],
    },
  },
  modules: {
    filtro,
  },
});
export const storeFiltroPesquisa = createStore<EstadoFiltroPesquisa>({
  state: {
    filtroPesquisa: {
      filtroPesquisa:{idNorma:'',filtroPesquisa:''}
    },
  },
  modules: {
    filtroPesquisa,
  },
});
export const storeStorageLocal = createStore<EstadoLocalStorage>({
  state: {
    localStorage: {
      localStorage:new Map<string,any>()
    },
  },
  modules: {
    localStorage,
  },
});


export function useStoreCustom(): Store<Estado> {
  return vuexUseStore(key);
}
export function useStoreFiltro(): Store<EstadoFiltro> {
  return vuexUseStore(keyFiltro);
}
export function useStoreFiltroPesquisa(): Store<EstadoFiltroPesquisa> {
  return vuexUseStore(keyFiltroPesquisa);
}
export function useStoreStorageLocal(): Store<EstadoLocalStorage> {
  return vuexUseStore(keyLocalStorage);
}
